import React, { useState } from "react";
import { Collapse, NavItem, NavLink as Link } from "reactstrap";
import "./sub-menu.scss";
import { Divider } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowRight from "../../../assets/icons/arrow-right.svg";
import { NavLink } from "react-router-dom";
import { routes } from "../../../constants/routes";

interface SubMenuSideBarProps {
  navSubMenu: any;
  collapsed: { isOpen: boolean; activePath: string };
  toggleCollapse: (collapsed: string) => void;
  handleIfNoPath: (path: string, from?: string) => void;
  setIsSidebarClick?: (value: boolean) => void;
  activeNavbar: any;
  setClickedActiveItem: (value: any) => void;
  openDropdown?: string | null;
  selectedPath?: string;
}
const SubMenuSideBar: React.FC<SubMenuSideBarProps> = ({
  navSubMenu,
  toggleCollapse,
  collapsed,
  handleIfNoPath,
  setIsSidebarClick = () => {},
  activeNavbar,
  setClickedActiveItem = () => {},
  openDropdown,
  selectedPath,
}) => {
  const { isOpen, activePath } = collapsed;
  const isDropdownOpen =  isOpen && activePath === navSubMenu.label;
  return (
    <div
      className={`nav-sub-menu-wrapper ${!isDropdownOpen ? "collapse-dropdown-nav-sub-menu" : ""}`}
    >
      <NavItem onClick={() => toggleCollapse(navSubMenu.label)}>
        <Link className={`submenu-item-nav`}>
          <div className="subment-itemnav-text">
            <img
              src={navSubMenu.icon}
              alt={navSubMenu.label}
              className="submenu-icon"
            />
            {navSubMenu.label}
          </div>
          <div
            className="side-bar-arrow"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            {!isDropdownOpen ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
          </div>
        </Link>
      </NavItem>

      {isDropdownOpen && (
        <>
          <Divider sx={{ borderColor: "rgba(152, 152, 152, 1)" }} />
          <Collapse isOpen={isDropdownOpen}>
            {navSubMenu.subMenu?.map((item: any, index: number) => (
              <NavItem key={index}>
                <NavLink
                  className={({ isActive }) => {
                    const isSelected = selectedPath === item.path;
                    return `submenu-item-nav collapse-submenu-item-nav ${
                      item.path && (isActive || isSelected) ? "active" : ""
                    }`;
                  }}
                  to={item.path || routes.DASHBOARD}
                  onClick={() => {
                    setIsSidebarClick(true);
                    handleIfNoPath(item.path, "submenu");
                    setClickedActiveItem({ ...activeNavbar });
                  }}
                >
                  <div className="subment-itemnav-text child-subment-itemnav-text">
                    <span>{item.label}</span>
                  </div>
                </NavLink>
              </NavItem>
            ))}
          </Collapse>
        </>
      )}
    </div>
  );
};

export default SubMenuSideBar;
